import { Content } from "@robe/core";
import { useMemo } from "react";
import { useData } from "./useData";

type UseMultipleContentsValue<T extends Content[]> = {
  [K in keyof T]: T[K][];
};

/**
 * @returns array of multiple contents fetched in the `multipleContents` field
 */
export const useMultipleContents = <TSource extends Content[]>(): UseMultipleContentsValue<TSource> => {
  const { multipleContents } = useData<Content, Content[], TSource>();

  return useMemo(() => multipleContents.map((c) => c.contents) as any, [multipleContents]);
};
